import './tableCell.css';

const TableCell = ({ item }) => {
    return (
      <div className="tableCell">
        {item}
      </div>
    )
};

export default TableCell;